import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { PageHeader, SectionCard, StatusBadge, Empty } from "@/components/shared";
import { fmtDate } from "@/lib/format";
import { Plus, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function Tasks() {
  const [rows, setRows] = useState([]);
  const [title, setTitle] = useState("");
  const [priority, setPriority] = useState("Medium");

  const load = () => api.get("/sales/tasks").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!title) return;
    try { await api.post("/sales/tasks", { title, priority }); setTitle(""); toast.success("Task created"); load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  const done = async (t) => { await api.patch(`/sales/tasks/${t.id}`, { status: t.status === "open" ? "done" : "open" }); load(); };

  const PRIO = { High: "text-red-600 bg-red-50", Medium: "text-amber-600 bg-amber-50", Low: "text-slate-500 bg-slate-100" };

  return (
    <div>
      <PageHeader title="Tasks & Follow-ups" subtitle="Track next actions across partners and projects." testid="tasks-page" />
      <SectionCard className="mb-6">
        <div className="flex flex-wrap gap-2">
          <input data-testid="task-title" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="New task…" className="flex-1 min-w-[200px] border border-slate-300 rounded-lg px-3 py-2 text-sm" />
          <select value={priority} onChange={(e) => setPriority(e.target.value)} className="border border-slate-300 rounded-lg px-3 py-2 text-sm bg-white">{["High", "Medium", "Low"].map((p) => <option key={p}>{p}</option>)}</select>
          <button data-testid="add-task-btn" onClick={create} className="flex items-center gap-1.5 text-white font-semibold px-4 py-2 rounded-lg" style={{ background: "var(--copper)" }}><Plus size={16} /> Add</button>
        </div>
      </SectionCard>
      <SectionCard className="!p-0">
        <div className="divide-y divide-slate-50">
          {rows.length === 0 && <Empty />}
          {rows.map((t) => (
            <div key={t.id} className="flex items-center gap-3 p-4">
              <button onClick={() => done(t)} data-testid={`task-check-${t.id}`}><CheckCircle2 size={20} className={t.status === "done" ? "text-emerald-600" : "text-slate-300"} /></button>
              <div className="flex-1">
                <p className={`text-sm ${t.status === "done" ? "line-through text-slate-400" : "text-slate-800"}`}>{t.title}</p>
                <p className="text-xs text-slate-400">{t.assigned_to} · {fmtDate(t.created_at)}</p>
              </div>
              <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${PRIO[t.priority] || PRIO.Low}`}>{t.priority}</span>
              <StatusBadge status={t.status === "done" ? "approved" : "pending"} />
            </div>
          ))}
        </div>
      </SectionCard>
    </div>
  );
}
